<script setup lang="ts">
interface Props {
  icon?: 'menu' | 'close';
  ariaLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  icon: 'menu',
  ariaLabel: 'Меню',
});
</script>

<template lang="pug">
q-btn(
  :aria-label="props.icon === 'close' ? 'Закрыть меню' : props.ariaLabel"
  color="white"
  text-color="black"
  round
  size="lg"
  dense
  unelevated
  )
  .icon-menu(v-if="icon === 'menu'")
    .line.line-1
    .line.line-2
  .icon-close(v-if="icon === 'close'").relative.size-16px
    .line.line-1
    .line.line-2
</template>

<style lang="sass">
.line
  width: 8px
  height: 2px
  border-radius: 2px
  background-color: black

.icon-menu
  .line-2
    margin-top: 4px

.icon-close

  .line
    width: 20px
    position: absolute
    left: -2px
    top: 7px
  .line-1
    transform: rotate(45deg)
  .line-2
    transform: rotate(-45deg)

    // margin: 0
</style>
